var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "properties-field", attrs: { id: _vm.id } }, [
    _c(
      "div",
      { staticClass: "wrap-properties" },
      [
        _c("div", { staticClass: "properties-field-title" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "close-properties",
              on: {
                click: function($event) {
                  _vm.$emit("close-configuration")
                }
              }
            },
            [_vm._v("\n        ×\n      ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "wrap-type" }, [
            _c("img", {
              attrs: {
                src: require("@/assets/new-form-ui/field-icon/" +
                  _vm.iconComponent +
                  ".svg")
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "text-type" }, [
              _vm._v(_vm._s(_vm.dataComponent.name.replace(/_/g, " ")))
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.componentType === "form_ui" ||
        _vm.componentType === "multiple_form_ui"
          ? _c("j-exp-manager-form", {
              ref: "componentFormRef",
              attrs: {
                "data-master": _vm.dataMaster,
                "data-component": _vm.dataComponent,
                "data-edit": _vm.dataEdit,
                "pages-id": _vm.pagesId,
                "is-multiple": _vm.componentType === "multiple_form_ui"
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.componentType === "canvas"
          ? _c("j-canvas-form", {
              ref: "componentFormRef",
              attrs: {
                "data-master": _vm.dataMaster,
                "data-component": _vm.dataComponent,
                "data-edit": _vm.dataEdit,
                "pages-id": _vm.pagesId
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.componentType === "html"
          ? _c("j-html-form", {
              ref: "componentFormRef",
              attrs: {
                "data-master": _vm.dataMaster,
                "data-component": _vm.dataComponent,
                "data-edit": _vm.dataEdit,
                "pages-id": _vm.pagesId
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.componentType === "embed_url"
          ? _c("j-embed-url-form", {
              ref: "componentFormRef",
              attrs: {
                "data-master": _vm.dataMaster,
                "data-component": _vm.dataComponent,
                "data-edit": _vm.dataEdit,
                "pages-id": _vm.pagesId
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.componentType.includes("attendance") ||
        _vm.componentType.includes("leave") ||
        _vm.componentType.includes("overtime") ||
        _vm.componentType.includes("timesheet") ||
        _vm.componentType === "hierarchy" ||
        _vm.componentType === "custom_hierarchy" ||
        _vm.componentType === "user_setup" ||
        _vm.componentType === "employee_setup" ||
        _vm.componentType === "access_management"
          ? _c("j-component-form", {
              ref: "componentFormRef",
              attrs: {
                "data-master": _vm.dataMaster,
                "data-component": _vm.dataComponent,
                "data-edit": _vm.dataEdit,
                "pages-id": _vm.pagesId
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "properties-field-button",
            class: { "justify-content-end": !_vm.dataEdit }
          },
          [
            _vm.dataEdit
              ? _c(
                  "button",
                  {
                    staticClass: "button-border",
                    on: {
                      click: function($event) {
                        _vm.$emit("delete-component")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-trash" }),
                    _vm._v(" Delete\n      ")
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c(
                "button",
                {
                  staticClass: "button-border mr-2",
                  on: {
                    click: function($event) {
                      _vm.$emit("close-configuration")
                    }
                  }
                },
                [_vm._v("\n          Close\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button-blue",
                  on: { click: _vm.applyComponent }
                },
                [_vm._v("\n          Apply\n        ")]
              )
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "title" }, [
      _vm._v("\n        Properties\n        "),
      _c("div", { staticClass: "title-badge" }, [_vm._v("Component")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e22c8d8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e22c8d8a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application-manager/detail/jComponentProperties.vue
// module id = null
// module chunks = 